import type { DayOfWeekName } from '@/api/types/desktopNotification.types';

export const DAY_ORDER: DayOfWeekName[] = [
  'Monday',
  'Tuesday',
  'Wednesday',
  'Thursday',
  'Friday',
  'Saturday',
  'Sunday',
];

// Days a notification may be scheduled on. DAY_ORDER keeps all seven because rows created before the
// weekend rule still have to sort and render; only the day picker is restricted.
export const SCHEDULABLE_DAY_ORDER: DayOfWeekName[] = DAY_ORDER.filter(
  (d) => d !== 'Saturday' && d !== 'Sunday',
);

export const DAY_SHORT_NAMES: Record<DayOfWeekName, string> = {
  Sunday: 'Sun',
  Monday: 'Mon',
  Tuesday: 'Tue',
  Wednesday: 'Wed',
  Thursday: 'Thu',
  Friday: 'Fri',
  Saturday: 'Sat',
};

export interface ScheduleSummaryEntry {
  dayOfWeek: DayOfWeekName;
  timeOfDay: string;
  isGenerationAnchor?: boolean;
}

// Mirrors ScheduleSummaryFormatter.Format on the server character for character, so the caption the
// admin sees while editing matches the summary the list page renders from the saved notification.
export function formatScheduleSummary(schedules: ScheduleSummaryEntry[]): string {
  if (!schedules.length) {
    return 'Weekly (no day selected)';
  }

  const orderIndex = (d: DayOfWeekName) => DAY_ORDER.indexOf(d);
  const ordered = [...schedules].sort((a, b) => orderIndex(a.dayOfWeek) - orderIndex(b.dayOfWeek));
  const parts = ordered.map((s) => {
    const time = s.timeOfDay.length >= 5 ? s.timeOfDay.slice(0, 5) : s.timeOfDay;
    const marker = s.isGenerationAnchor ? ' (generation)' : '';
    return `${DAY_SHORT_NAMES[s.dayOfWeek] ?? s.dayOfWeek} ${time}${marker}`;
  });

  return `Weekly on ${parts.join(', ')}`;
}
